import { PlusOutlined } from '@ant-design/icons';
import { Card, Modal, Space, Spin, Upload, message } from 'antd';
import { useEffect, useState } from 'react';
import { IoDocumentTextOutline } from 'react-icons/io5';

import axios from 'axios';
import './style.less';

const UPLOAD_ERROR_MESSAGE = 'Зураг оруулахад алдаа гарлаа';

const Facts = ({ facts = {}, getDetailData }) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [removing, setRemoving] = useState(false);

  useEffect(() => {
    const uploadedFiles = facts.images?.map((image) => ({ url: image }));
    if (facts.signature) uploadedFiles.push({ url: facts.signature });
    setFileList(uploadedFiles);
  }, [facts]);

  const uploadProps = {
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    fileList,
  };

  const handleUpload = async ({ file }) => {
    const formData = new FormData();
    fileList.forEach((file) => {
      formData.append('files[]', file);
    });
    setUploading(true);
    try {
      // Storage сервисийн алдааны текст хэрэглэгчид ойлгомжгүй тул interceptor-ын
      // toast-ыг хааж, доор зургийн тухай тодорхой мессеж харуулна
      const { data } = await axios.post(
        `${
          process.env.REACT_APP_STORAGE_URL
        }/upload/operator/merchant?fileName=image${Date.now()}&uid=${file.uid}`,
        formData,
        { skipErrorToast: true }
      );
      if (data?.statusCode === 200) {
        const body = {
          code: facts?.code,
          image: data?.result?.location,
        };
        await axios.post('/api/v1.0/request/uploadFile', body);
        getDetailData(facts?._id);
        setFileList([]);
        message.success('Амжилттай хуулагдлаа.');
      } else {
        message.error(UPLOAD_ERROR_MESSAGE);
      }
    } catch (error) {
      console.error('Зураг оруулах: ', error);
      // uploadFile-ын алдааг interceptor өөрөө мэдэгдсэн — зөвхөн storage-ийн
      // (toast хаасан) хүсэлт унасан үед локал мессеж гаргана
      if (error?.config?.skipErrorToast) message.error(UPLOAD_ERROR_MESSAGE);
    } finally {
      setUploading(false);
    }
  };

  const removeFile = async ({ file }) => {
    const body = {
      code: facts?.code,
      image: file.url,
    };
    setRemoving(true);
    try {
      const { data } = await axios.post('/api/v1.0/request/removeFile', body);
      if (data.statusCode === 200) {
        getDetailData(facts?._id);
      }
    } catch (error) {
      console.error('Зураг устгах: ', error);
    } finally {
      setRemoving(false);
    }
  };

  /**
   * Upload нь onRemove-оос Promise авбал түүний үр дүнг хүлээнэ: `false` бол
   * зураг жагсаалтаас хасагдахгүй. Ингэснээр санамсаргүй дарахад шууд
   * устгагдахаас сэргийлж, баталгаажуулсны дараа л onChange (removed) дуудагдана.
   */
  const confirmRemove = () =>
    new Promise((resolve) => {
      Modal.confirm({
        title: 'Зургийг устгах уу?',
        okText: 'Устгах',
        cancelText: 'Болих',
        okButtonProps: { danger: true },
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });

  const onChangeFile = async ({ file }) => {
    if (file?.status === 'removed') {
      await removeFile({ file });
    } else {
      await handleUpload({ file });
    }
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div className="upload_btn_text">Зураг оруулах</div>
    </div>
  );
  return (
    <>
      <Space direction="vertical" size={16} style={{ width: '100%', padding: 16 }}>
        <Card
          title={
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <IoDocumentTextOutline style={{ display: 'block', fontSize: '1em' }} />
              Баримт оруулах
            </span>
          }
          size="middle"
        >
          <Spin spinning={uploading || removing}>
            <div style={{ paddingInline: '1px', paddingBottom: '16px' }}>
              <Upload
                {...uploadProps}
                listType="picture-card"
                fileList={fileList}
                onChange={onChangeFile}
                onRemove={confirmRemove}
                disabled={uploading || removing}
              >
                {uploadButton}
              </Upload>
            </div>
          </Spin>
        </Card>
      </Space>
    </>
  );
};

export default Facts;
